module.exports = __webpack_public_path__ + "img/menu-mobile.d346927b.svg";